/**
* GENERATED BY RPC GEN - LESS MODIFY BY HAND
* security-service.ts  2024-05-22T11:45:33+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'bt-rpc-base';

import type { OtpCheck, Passcode, PublicKey, AliCaptchaCheck } from './auth-dto';

const _ = 'Security/';

export class SecurityService {

  constructor(readonly r: RpcService) {}
  // 基于c-id和ip对用户名进行绑定预检
  aliCheck(d:AliCaptchaCheck, m?: M): R<Passcode>{
    return this.r.async(_ + 'aliCheck', d, m);
  }
  // 加密密码等用的rsa公钥/Jwk格式
  encryptKey(m?: M): R<PublicKey>{
    return this.r.async(_ + 'encryptKey', undefined, m);
  }
  // 临时码预检，成功发送临时吗,支持手机
  otpCheck(d:OtpCheck, m?: M): R<Passcode>{
    return this.r.async(_ + 'otpCheck', d, m);
  }
  // 特定几个号码，不真实发送
  otpMock(d:OtpCheck, m?: M): R<Passcode>{
    return this.r.async(_ + 'otpMock', d, m);
  }
}
